export const headerMenu = [
  { label: "Home", route: "/home" },
  { label: "Services", route: "/services" },
  {
    label: "About Us",
    route: "/about-us",
  },
  { label: "Contact", route: "/contact" },
];
